import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router';
import config, { loadConfig } from '@/services/ConfigService'

export const initSentry = async (app: App, router: Router) => {
  await loadConfig()

  Sentry.init({
    app,
    dsn: "https://fb2fa4315bf96c5536adb43889fdcafa@o876503.ingest.us.sentry.io/4508278750445568",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false
      })
    ],
    enabled: config.sentry.enabled,
    // Tracing
    tracesSampleRate: 0.25, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/cdi.*api.*\.dk/
    ],
    ignoreTransactions: [
      /^GET \/healthz\/liveness$/,
      'healthz'
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Vue specific
    trackComponents: true,
    release: 'cdi-web@' + import.meta.env.VITE_VERSION,
    environment: config.environment ?? 'unknown'
  });
}

export function attachFeedback() {
  const reportButton = document.querySelector('#report-bug-button')

  if (reportButton) {
    const feedback = Sentry.getFeedback()

    if (feedback) {
      feedback.attachTo(reportButton)
    }
  }
}